// removed by extract-text-webpack-plugin
module.exports = {"EthereumAddressInput":"_2_pbcCBHCpIHwR6NEBk9nK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EthereumAddressInput.scss
// module id = 1280
// module chunks = 0